import type { ReactNode } from "react";
import { createContext, useContext } from "react";

import type { NewsletterSignUpClickTriggerPoint } from "scmp-app/components/tracking/google-analytics-4/types";

type ContextValue = {
  ga4CustomParameter?: GA4CustomParameter;
};

type GA4CustomParameter = {
  triggerPoint?: NewsletterSignUpClickTriggerPoint;
};

const NewsletterPreviewContext = createContext<ContextValue>({});

type Props = ContextValue & {
  children: ReactNode;
};

export const NewsletterPreviewContextProvider: React.FunctionComponent<Props> = ({
  children,
  ...value
}) => (
  <NewsletterPreviewContext.Provider value={value}>{children}</NewsletterPreviewContext.Provider>
);

NewsletterPreviewContext.displayName = "NewsletterPreviewContext";

export const useNewsletterPreviewContext = () => useContext(NewsletterPreviewContext);
